import { useStaticQuery, graphql } from "gatsby"

export type SiteConfig = {
  enableCoupons: boolean
  enableAffirmCanada: boolean
  enableAffirmUS: boolean
  enableFlex: boolean
  payWithFlexMessage: string
  payWithFlexButtonText: string
  beforeFlexSubscriptionCreditCardMessage: string
  beforeAffirmSubscriptionCreditCardMessage: string
  toggleCheckoutFlexText: string
  toggleCheckoutCardText: string
  toggleCheckoutAffirmText: string
  payWithAffirmMessage: string
  payWithAffirmButtonText: string
  checkoutCreateAccountMessage: string
  checkoutNewsletterMessage: string
  cookieBanner?: string
  enableGifts: boolean
  enableAffirmPriceDisplayBadge: boolean
  enableFlexPriceDisplayBadge: boolean
  logo: any
  logoOnDart: any
  enableSchemaTags?: boolean
  maintenanceModeEnabled?: boolean
}

export const useSiteConfig = () => {
  const { sensaiSiteConfig } = useStaticQuery(
    graphql`
      query {
        sensaiSiteConfig {
          enableSchemaTags
          enableCoupons
          toggleCheckoutCardText
          toggleCheckoutAffirmText
          payWithAffirmMessage
          payWithAffirmButtonText
          checkoutCreateAccountMessage
          checkoutNewsletterMessage
          cookieBanner
          enableGifts
          enableAffirmPriceDisplayBadge
          enableFlexPriceDisplayBadge
          enableAffirmCanada
          enableAffirmUS
          enableFlex
          payWithFlexMessage
          payWithFlexButtonText
          toggleCheckoutFlexText
          beforeFlexSubscriptionCreditCardMessage
          beforeAffirmSubscriptionCreditCardMessage
          maintenanceModeEnabled
          logo {
            url
            imageFile {
              childImageSharp {
                gatsbyImageData(
                  placeholder: NONE
                  layout: FIXED
                  height: 135
                  width: 480
                )
              }
            }
          }
          logoOnDark {
            url
            imageFile {
              childImageSharp {
                gatsbyImageData(
                  placeholder: NONE
                  layout: FIXED
                  height: 135
                  width: 480
                )
              }
            }
          }
        }
      }
    `
  )

  return sensaiSiteConfig as SiteConfig
}
